import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

/**
 * Initialisiert Swiper-Slider für Weekly-Elemente mit responsiven Breakpoints
 * und Navigation für die Standardansicht.
 */
export function initWeeklyScrollbar(el) {
    for (let scrollbar of el) {
        let childrenCount = scrollbar.querySelectorAll('.swiper-wrapper > *').length;
        let breakpoints = {
            xs: {
                items: 1.2,
            },
            sm: {
                items: 2.2,
            },
            md: {
                items: 3.2,
            },
            lg: {
                items: 3.2,
            },
            xlg: {
                items: 4.2,
            }
        }
        let gridBreakpoints = {};
        gridBreakpoints.sm = 768;
        gridBreakpoints.md = 1024;
        gridBreakpoints.lg = 1250;
        gridBreakpoints.xlg = 1670;
        if (typeof GLOBALS!== "undefined") {
            gridBreakpoints.sm = GLOBALS.gridBreakpoints.sm;
            gridBreakpoints.md = GLOBALS.gridBreakpoints.md;
            gridBreakpoints.lg = GLOBALS.gridBreakpoints.lg;
            gridBreakpoints.xlg = GLOBALS.gridBreakpoints.xlg;
        }
        Swiper.use([Autoplay, Navigation]);
        new Swiper(scrollbar, {
            speed: 500,
            initialSlide: 0,
            spaceBetween: 30,
            navigation: {
                nextEl: scrollbar.querySelector('.swiper-button-next'),
                prevEl: scrollbar.querySelector('.swiper-button-prev'),
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    spaceBetween: 15
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                },
                1670: {
                    slidesPerView: breakpoints.xlg.items,
                }
            }
        });
    }
}

/**
 * Initialisiert Swiper-Slider für die Login-Ansicht mit angepassten
 * responsiven Breakpoints und Navigation.
 */
export function initWeeklyScrollbarLogin(el) {
    for (let scrollbar of el) {
        let childrenCount = scrollbar.querySelectorAll('.swiper-wrapper > *').length;
        let breakpoints = {
            xs: {
                items: 1.2,
            },
            sm: {
                items: 2.2,
            },
            md: {
                items: 3.2,
            },
            lg: {
                items: 3.2,
            },
            xlg: {
                items: 3.2,
            }
        }
        let gridBreakpoints = {};
        gridBreakpoints.sm = 768;
        gridBreakpoints.md = 1024;
        gridBreakpoints.lg = 1250;
        gridBreakpoints.xlg = 1670;
        if (typeof GLOBALS!== "undefined") {
            gridBreakpoints.sm = GLOBALS.gridBreakpoints.sm;
            gridBreakpoints.md = GLOBALS.gridBreakpoints.md;
            gridBreakpoints.lg = GLOBALS.gridBreakpoints.lg;
            gridBreakpoints.xlg = GLOBALS.gridBreakpoints.xlg;
        }
        Swiper.use([Autoplay, Navigation]);
        new Swiper(scrollbar, {
            speed: 500,
            initialSlide: 0,
            spaceBetween: 30,
            navigation: {
                nextEl: scrollbar.querySelector('.swiper-button-next'),
                prevEl: scrollbar.querySelector('.swiper-button-prev'),
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    spaceBetween: 15
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                },
                1670: {
                    slidesPerView: breakpoints.xlg.items,
                }
            }
        });
    }
}